<template>
  <div>
    <div v-show="edit">
      <ejs-datetimepicker
        ref="dateObj"
        :locale="locale"
        :placeholder="waterMark"
        :value="date"
        :format="dateFormat"
        :allowEdit="true"
        :showClearButton="false"
        :step="15"
        :enableMask="true"
        :strictMode="true"
        :change="onDateChanged"
        :min="minimumDate"
        :blur="onDateBlur"
      ></ejs-datetimepicker>
    </div>
    <div v-show="!edit">
      <v-icon v-if="icon" size="18" color="darkCharcoal" class="mr-2">{{
        icon
      }}</v-icon>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span class="label-m" v-bind="attrs" v-on="on">
            {{ formatDate(new Date(date), displayDateFormat) }}
          </span>
        </template>
        <span>{{ lable }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="updateMeetingPermission">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            class="ml-2"
            x-small
            color="secondary"
            width="24"
            min-width="24"
            v-bind="attrs"
            v-on="on"
            @click="onDateEdit"
          >
            <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
          </a-btn>
        </template>
        <span>{{ getEditIconText() }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { formatDate } from "@/utils/util";
import { mapGetters } from "vuex";
import { loadCldr } from "@syncfusion/ej2-base";
import {
  DateTimePickerPlugin,
  DateTimePicker,
  MaskedDateTime,
} from "@syncfusion/ej2-vue-calendars";

Vue.use(DateTimePickerPlugin);
DateTimePicker.Inject(MaskedDateTime);

loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/ja/ca-gregorian.json"),
  require("cldr-data/main/ja/numbers.json"),
  require("cldr-data/main/ja/timeZoneNames.json")
);

export default {
  name: "InPlaceDateEditor",
  provide: {
    datetimepicker: [MaskedDateTime],
  },
  props: {
    value: {
      type: [String, Date],
      default: "",
    },
    minDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    endDate: {
      type: [String, Date],
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
    lable: "",
    type: "",
  },
  data() {
    return {
      waterMark: "Select a datetime",
      edit: false,
      rules: {
        required: (value) => !!value || "Field required.",
      },
    };
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    locale() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.locale !== "ja" ? "dd/MM/yyyy hh:mm aaa" : "yyyy/MM/dd HH:mm";
    },
    dateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm";
    },
    date() {
      return new Date(this.value);
    },
    minimumDate() {
      return this.type !== "start"
        ? this.roundTimeQuarterHour(new Date(this.minDate))
        : null;
    },
    endDateTime() {
      return this.endDate ? new Date(this.endDate) : new Date();
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
  },
  methods: {
    formatDate,
    onStartDateChange,
    roundTimeQuarterHour,
    onDateChanged,
    onDateBlur,
    AddMinutesToDate(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },
    onDateEdit() {
      this.edit = true;
      this.$nextTick(() => {
        this.$refs.dateObj.show("date");
        this.$refs.dateObj.focusIn();
      });
    },
    getEditIconText() {
      switch (this.lable) {
        case this.$t("agenda.lblStartTime"):
          return this.$t("agenda.tipUpdateStartTime");
        case this.$t("agenda.lblEndTime"):
          return this.$t("agenda.tipUpdateEndTime");
        default:
          return this.$t("btnEdit");
      }
    },
  },
};

function onDateBlur(event) {
  if (
    JSON.stringify(event.model.initValue) !==
    JSON.stringify(event.model.currentDate)
  ) {
    this.$eventHub.$emit("onMeetingUpdate");
  }
  this.edit = false;
}

function onDateChanged(event) {
  this.edit = false;
  const date = new Date(event.value);
  this.onStartDateChange(date);
}

function onStartDateChange(date) {
  this.$emit("input", date.toUTCString() || new Date().toUTCString());
  if (this.endDateTime.getTime() <= date.getTime()) {
    const newDate = this.AddMinutesToDate(new Date(date), 5).toUTCString();
    if (this.type === "start") {
      this.$emit("update:endDate", newDate);
    }
  }
}

// function onEndDateChange(updatedEndDate) {
//   if (this.type === "end") {
//     let date = updatedEndDate.toUTCString();
//     if (updatedEndDate.getTime() <= this.date.getTime()) {
//       date = this.AddMinutesToDate(
//         new Date(updatedEndDate.toUTCString()),
//         5
//       ).toUTCString();
//     }
//     // this.$emit("input", date);
//     this.$emit("update:endDate", date);
//   }
// }

function roundTimeQuarterHour(time) {
  var timeToReturn = new Date(time);

  timeToReturn.setMilliseconds(
    Math.round(timeToReturn.getMilliseconds() / 1000) * 1000
  );
  timeToReturn.setSeconds(Math.round(timeToReturn.getSeconds() / 60) * 60);
  timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);
  return timeToReturn;
}
</script>

<style>
</style>